import axios, { AxiosInstance, AxiosRequestConfig, AxiosError } from 'axios';
import messageBus from '../util/messageBus';

export default class Adapter {

  public baseUrl: string;
  public axios: AxiosInstance;

  constructor() {
    this.baseUrl = '/api/v1';
    this.axios = axios.create({
      baseURL: this.baseUrl,
      timeout: 0, // no timeout
    });

    // Add a response interceptor
    this.axios.interceptors.response.use((response) => {
      // Do nothing with response data if success
      return response;
    }, (error: AxiosError) => {
      //Do not show if already on login page
      if (error.response && error.response.status === 401) {
        messageBus.$emit('auth-error');
      }
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      return Promise.reject(error);
    });

  }

  public request(options: AxiosRequestConfig) {
    const reqOptions: AxiosRequestConfig = Object.assign({}, options) as AxiosRequestConfig;

    // Add Headers:
    const origHeaders = options.headers;
    const additionalHeaders = this.getHeadersForRequest();
    if (origHeaders) {
      // Merge them:
      const newOptions = additionalHeaders;
      Object.assign(newOptions, origHeaders); // Overwrite standard with user defined ones
      reqOptions.headers = newOptions;
    } else {
      reqOptions.headers = additionalHeaders;
    }

    return this.axios.request(reqOptions);
  }

  public getHeadersForRequest() { // Unused for now, does nothing
    const headers = {};
    return headers;
  }

}
